/** Difficulty 1-5 as filled dots — quicker to scan than a number. */
export default function DifficultyDots({ level }: { level: number }) {
  const filled = Math.max(1, Math.min(5, level));
  return (
    <span className="diff" title={`Difficulty ${filled} of 5`} aria-label={`Difficulty ${filled} of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span key={i} className={`diff-dot${i <= filled ? ' diff-dot--on' : ''}`} />
      ))}
    </span>
  );
}
